module.exports = __webpack_public_path__ + "img/MoonSword 6.c4bbd4d4.png";